// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"cca11d90","145":"cca11d90","160":"cca11d90","650":"cca11d90","787":"39bb0775"}[chunkId] + ".chunk.js";
};